import {z} from 'zod';

enum ToolCallResultStatus {
  Success = 'success',
  PartialSuccess = 'partialSuccess',
  Failure = 'failure',
}

const toolCallResultSchema = z.object({
  status: z
    .nativeEnum(ToolCallResultStatus)
    .describe(
      `Use "${ToolCallResultStatus.Success}" if you can fully execute the request. Use "${ToolCallResultStatus.PartialSuccess}" if you can partially execute the request. Use "${ToolCallResultStatus.Failure}" if you cannot execute the request.`,
    ),
  failureReason: z
    .string()
    .nullable()
    .optional()
    .describe(
      'Describe why the request failed (If information is missing, advise which . If the request cannot be supported, advise why)',
    ),
  unsupportedRequestPart: z
    .string()
    .nullable()
    .optional()
    .describe(
      'If some parts of the request could not be supported, describe what was not supported',
    ),
});

export {toolCallResultSchema, ToolCallResultStatus};

